import decorateComponentWithProps from 'decorate-component-with-props'
import RichTextEditorButton from '../custom-blocks/button'
export default (
  config: Record<string, any> = {},
): {
  blockRendererFn: (
    block: any,
    arg1: {
      getEditorState: () => any
    },
  ) => null | {
    component: any
    editable: boolean
  }
} => {
  const theme = config.theme ? config.theme : {}
  let Button = RichTextEditorButton

  if (config.decorator) {
    Button = config.decorator(Button)
  }

  const ThemedButton = decorateComponentWithProps(Button, {
    theme,
  })
  return {
    blockRendererFn: (
      block: Record<string, any>,
      {
        getEditorState,
      }: {
        getEditorState: () => Record<string, any>
      },
    ) => {
      if (block.getType() === 'atomic') {
        const contentState = getEditorState().getCurrentContent()
        const entity = block.getEntityAt(0)
        if (!entity) return null
        const type = contentState.getEntity(entity).getType()

        if (type === 'button') {
          return {
            component: ThemedButton,
            editable: false,
          }
        }

        return null
      }

      return null
    },
  }
}
export const Button = RichTextEditorButton
